// Bridge to the Android NetPrinterPlugin (android/.../NetPrinterPlugin.java).
// Ethernet / Wi-Fi thermal printers listen for raw ESC/POS on a TCP socket
// (port 9100 by convention). The WebView can't open raw TCP sockets, so on the
// native app the network printer transport goes through this plugin. Used by
// src/services/netPrinter.ts for the billing receipt and per-department KOTs.

import { registerPlugin } from '@capacitor/core';
import { isNativeApp } from './nativeUsb';

interface NetPrinterNativePlugin {
  print(opts: { ip: string; port: number; data: string }): Promise<void>;
}

const NetPrinterNative = registerPlugin<NetPrinterNativePlugin>('NetPrinter');

export { isNativeApp };

// Open a TCP socket to ip:port and stream raw ESC/POS bytes. Rejects when the
// printer is unreachable / the connection times out.
export async function netPrint(ip: string, port: number, data: Uint8Array): Promise<void> {
  await NetPrinterNative.print({ ip, port, data: toBase64(data) });
}

function toBase64(bytes: Uint8Array): string {
  let binary = '';
  const CHUNK = 0x8000; // String.fromCharCode arg limit safety
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...Array.from(bytes.subarray(i, i + CHUNK)));
  }
  return btoa(binary);
}
